export const getFetchCareUrl = (slug: string) => `/hib/care/${slug}/`;
